import { render, staticRenderFns } from "./otherRk.vue?vue&type=template&id=73b4b5c9&scoped=true"
import script from "./otherRk.vue?vue&type=script&lang=js"
export * from "./otherRk.vue?vue&type=script&lang=js"
import style0 from "./otherRk.vue?vue&type=style&index=0&id=73b4b5c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b4b5c9",
  null
  
)

export default component.exports